import dffacBanner from "../images/dffac-banner.png";

const DFFACBannerSection = () => {
  return (
    <section className="pt-[72px] px-5">
      <div className="max-w-[1222px] mx-auto flex flex-col md:flex-row gap-[46px] md:gap-0 bg-secondary-dark-navy-500 border-2 border-secondary-dark-navy-400 rounded-[20px] md:rounded-[40px]">
        <div className="flex-1 text-white px-6 pt-[56px] md:p-[56px] flex flex-col items-start justify-center gap-4 md:gap-8">
          <h2 className="text-2xl font-semibold">
            Deployment Fee-Free Amazon Connect
          </h2>
          <p className="text-lg">
            Deployment Fee-Free Amazon Connect: Amazon Connect Customer enabled
            for your clients within hours! Yes, you heard that right. Zero
            dollar deployment & deployed within the day
          </p>

          <a
            href="https://icxeed.sharepoint.com/:b:/r/sites/iCXeed/Shared%20Documents/Client%20Proposals/3%20Amazon%20Connect/AA%20CXperience%20Builder/Brochure_iCXeed_Amazon%20Connect_CXperience%20Builder.pdf?d=w620708d045f148ff8612d4c556aaa99c&csf=1&web=1&e=1yLKqa"
            target="_blank"
            rel="noopener noreferrer"
            className="glow-button get-started-button w-full md:w-auto"
          >
            <span>Download Brochure</span>
            <img
              className="background-image-button"
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/hover-button.png"
              alt="Hover Button"
            />
          </a>
        </div>
        <div className="flex-1 flex items-center justify-center pt-6 px-6">
          <img
            src={dffacBanner}
            alt="Deployment Fee-Free Amazon Connect Brochure Preview"
            className="max-w-full h-auto "
          />
        </div>
      </div>
    </section>
  );
};

export default DFFACBannerSection;
